import { useState, useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { GetConnectionStatus } from "../utils/GetConnectionStatus";

export const PrivateRoute = ({ children }) => {
    const { isAuthenticated, loginWithRedirect, isLoading, getAccessTokenSilently, user } = useAuth0();

    const [state, setState] = useState({
        isAccountValid: true
    });

    //Get necessary data on screen load
    useEffect(() => {
        if (!isLoading) {
            if (isAuthenticated && user && user.sub) {
                const userId = user.sub.split('|')[1];
                const checkValidAccount = async () => {
                    const valid = await isValidAccount(userId);
                    setState(previousInputs => ({ ...previousInputs, isAccountValid: valid }));
                };
                checkValidAccount();
            }
        }
    }, [isLoading]);

    const isValidAccount = async (userId) => {
        let isAccountValid = false;
        const token = await getAccessTokenSilently();
        const connStatus = await GetConnectionStatus(token, userId);

        if (connStatus && connStatus.status && (connStatus.status === 404 || connStatus.status === 401)) {
            //Leave isAccountValid set to false
        } else {
            isAccountValid = true;
        }
        return isAccountValid;
    }

    const AccountSetup = () => {
        return (
            <div>
                {state.isAccountValid && isAuthenticated && (children)}
                {isLoading && (null)}
                {!isAuthenticated && !isLoading && (
                    <div className="login-message text-center">
                        <Row>
                            <Col></Col>
                            <Col>
                                <h1 className="mt-9 mb-3">Welcome</h1>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col></Col>
                            <Col xs={7}>
                                <h3 className="mt-2 mb-3">To view trades and make adjustments to your account login below.</h3>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col></Col>
                            <Col>
                                <Button
                                    className="mt-4 mb-3"
                                    variant="outline-success"
                                    onClick={() => loginWithRedirect({
                                        appState: {
                                            returnTo: window.location.pathname
                                        }
                                    })}
                                >
                                    Login
                                </Button>
                            </Col>
                            <Col></Col>
                        </Row>
                    </div>
                )}
                {
                    !isLoading && isAuthenticated && !state.isAccountValid && (
                        <Container>
                            <Row>
                                <Col></Col>
                                <Col xs={10} className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left">
                                    <h3 className="border-bottom mb-2 pb-2 text-danger">
                                        Private Use Only.
                                    </h3>
                                    <h4 className="mb-2 pb-2 text-danger">
                                        If you are a new user who has been approved to use this website, your account is in the process of being set up. Check back later.
                                    </h4>
                                    <h4 className="mb-2 pb-2 text-danger">
                                        Contact your licensor if you believe you have reached this message in error.
                                    </h4>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Container>
                    )
                }
            </div>
        )
    }

    return <AccountSetup />
};